import { ReactNode } from "react";
import { useFeature } from "./hooks";
import { FeatureKey } from "./types";

interface FeatureGateProps {
  feature: FeatureKey;
  children: ReactNode;
}

export function FeatureGate({ feature, children }: FeatureGateProps) {
  const allowed = useFeature(feature);
  if (!allowed) return null;
  return <>{children}</>;
}
